import React from "react";
import { Survey, SurveySegment, ThemeReportData, IndicatorReport } from "../../../amorg-common";
import { QuestionSummaryPanel } from "./QuestionSummaryPanel";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { P } from "../../../designSystem/typography/Body";
import { H3 } from "../../../designSystem/typography/Heading";

type IndicatorPanelProps = {
    survey: Survey,
    themes: ThemeReportData[],
    segmentFilter: SurveySegment[][],
    showComments:boolean,
    siteId:string,
}
export function IndicatorPanel(props: IndicatorPanelProps): JSX.Element {

    const allThemedQuestions = props.themes.flatMap(t => t.questionData);
    const indicatorReport = new IndicatorReport(props.survey, allThemedQuestions.map(q => q.questionReport));

    return (
        <>
            {indicatorReport.data.map(ir => 
                <QuestionSummaryPanel
                    key={ir.indicator}
                    survey={props.survey}
                    header={
                        <Flex flexDirection="column">
                            <H3>{ir.indicator}</H3>
                            <P>
                                Indikatoren er anvendt på {allThemedQuestions.filter(q => q.surveyQuestion.indicators.includes(ir.indicator)).length} spørgsmål,
                                der i alt er blevet besvaret {ir.selections.totalSelections} gange.
                            </P>
                        </Flex>
                    }
                    siteId={props.siteId}
                    summaryStats={ir.selections}
                    questions={allThemedQuestions.filter(q => q.surveyQuestion.indicators.includes(ir.indicator))}
                    segmentFilter={props.segmentFilter}
                    showComments={props.showComments} />
            )}
        </>
    );
}